import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {ExceededModal} from 'entities/user';
import useCanCreateServer from 'features/server/model/useCanCreateServer';
import {useCreateGate, CreateEntityButton} from 'entities/tariff';

import ServerModal from '../ServerModal';

interface ICreateServerButtonProps {
    disabled?: boolean;
    serversCount?: number;
}

const CreateServerButton: React.FC<ICreateServerButtonProps> = ({disabled, serversCount}) => {
    const {open, close, isCreateOpen, isExceededOpen} = useCreateGate(useCanCreateServer({serversCount}));

    return (
        <>
            <CreateEntityButton ariaLabel={t`Добавить сервер`} onClick={open} disabled={disabled}>
                <Trans id="button.add.server" message="Добавить сервер"/>
            </CreateEntityButton>
            <ServerModal open={isCreateOpen} handleClose={close}/>
            <ExceededModal isOpen={isExceededOpen} handleClose={close} type="servers"/>
        </>
    );
};

export default CreateServerButton;
